export function getMinuteSecondDuration(timeInMs: number) {
  let output = "";
  const time = new Date();
  time.setTime(timeInMs);

  const hours = time.getUTCHours();
  const minutes = time.getUTCMinutes();
  const seconds = time.getUTCSeconds();

  if (hours > 0) {
    output += `${hours}h`;
  }
  if (minutes > 0) {
    output += `${minutes}m`;
  }
  if (seconds > 0) {
    output += `${seconds}s`;
  }

  return output;
}

export function formatDateUS(dateTime: Date | string | number) {
  return new Intl.DateTimeFormat("en-US", { dateStyle: "long" }).format(
    new Date(dateTime),
  );
}

export const getYear = (date: Date): string => {
  return date.getFullYear().toString();
};

export const getQuarter = (date: Date) => {
  return Math.floor((date.getMonth() + 3) / 3);
};

export const getYearQuarter = (date: Date): string => {
  return `${getYear(date)}-Q${getQuarter(date)}`;
};
